import script from "./Advertising.vue?vue&type=script&lang=ts&setup=true"
export * from "./Advertising.vue?vue&type=script&lang=ts&setup=true"

import "./Advertising.vue?vue&type=style&index=0&id=71b90c28&lang=scss"

const __exports__ = script;

export default __exports__